export default __webpack_public_path__ + "static/media/icon_USDT.c37c1585.svg";